/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/MDBox";
import GRNStatusController from "Controller/GRNStatusController";
import { TextField } from "@mui/material";
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

function GRNStatus() {
  const { columns, rows, paginationModel, setPaginationModel, rowCount, setPONumber, poNumber } =
    GRNStatusController();

  const theme = useTheme();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {cloading && <NewLoader></NewLoader>} */}
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="error"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                GRN Status
              </MDTypography>
            </MDBox>

            {/* Filters */}
            <MDBox display="flex" justifyContent="center" gap={2} alignItems="center" px={2} pt={2}>
              <TextField
                label="PO Number"
                size="medium" // bigger size
                sx={{ minWidth: 180 }}
                value={poNumber}
                onChange={(e) => setPONumber(e.target.value)}
              />
              <MDButton
                color={"error"}
                onClick={() => {
                  setPONumber("");
                  localStorage.removeItem("poNumbergn");
                }}
              >
                Reset
              </MDButton>
            </MDBox>

            <MDBox pt={3} pb={2} px={2} sx={{ height: "50%", width: "100%" }}>
              {rows.length > 0 ? (
                <DataGrid
                  rows={rows}
                  columns={columns}
                  disableSelectionOnClick
                  pagination
                  paginationMode="server"
                  sortingMode="server"
                  filterMode="server"
                  rowCount={rowCount}
                  page={paginationModel.page} // current page
                  pageSize={paginationModel.pageSize} // current page size
                  onPageChange={(newPage) => {
                    setPaginationModel({ ...paginationModel, page: newPage });
                  }}
                  onPageSizeChange={(newPageSize) => {
                    setPaginationModel({ ...paginationModel, pageSize: newPageSize, page: 0 });
                  }}
                  autoHeight
                  componentsProps={{
                    pagination: {
                      labelRowsPerPage: "", // hide label text
                      rowsPerPageOptions: [], // hide dropdown
                    },
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiDataGrid-columnHeaders": {
                      fontWeight: "bold",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "1px solid #f0f0f0",
                      textAlign: "center",
                    },
                    // "& .no-ellipsis": {
                    //   overflow: "visible !important",
                    //   textOverflow: "unset !important",
                    //   whiteSpace: "normal !important",
                    // },
                  }}
                />
              ) : (
                <MDBox display="flex" justifyContent="center" alignItems="center" height={300}>
                  <MDTypography variant="caption" fontWeight="bold" sx={{ fontSize: "1rem" }}>
                    No data available!
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

export default GRNStatus;
